import { render, staticRenderFns } from "./create-update-field.vue?vue&type=template&id=66a7781a&scoped=true"
import script from "./create-update-field.vue?vue&type=script&lang=js"
export * from "./create-update-field.vue?vue&type=script&lang=js"
import style0 from "./create-update-field.vue?vue&type=style&index=0&id=66a7781a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a7781a",
  null
  
)

export default component.exports